import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Index from '../views/erp-site/index'
import Index from '@/views/pc/index'
import About from '@/views/pc/about'
import Solution from '@/views/pc/solution'
import Cooperation from '@/views/pc/cooperation'
import Institute from '@/views/pc/institute'
import InstituteInfo from '@/views/pc/instituteInfo'
import Test from '@/views/test/test'
import IndexApp from '@/views/app/index'

Vue.use(Router)
//添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // }
    {
      path: '/refresh',
      name: 'Refresh',
      component: () => import('@/views/pc/refresh')
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/indexApp',
      name: 'IndexApp',
      // component: IndexApp
      // name: 'AboutApp',
      // component: AboutApp
      component: () => import('@/views/app/index')
      // meta: { title: '首页', noCache: false }
    },
    {
      path: '/aboutApp',
      name: 'AboutApp',
      component: () => import('@/views/app/about')
    },
    {
      path: '/sysIntroApp',
      name: 'SysIntroApp',
      component: () => import('@/views/app/sysIntro')
    },
    {
      path: '/solutionApp',
      name: 'SolutionApp',
      component: () => import('@/views/app/solution')
    },
    {
      path: '/cooperationApp',
      name: 'CooperationApp',
      component: () => import('@/views/app/cooperation')
    },
    {
      path: '/instituteApp',
      name: 'InstituteApp',
      component: () => import('@/views/app/institute')
    },
    {
      path: '/instituteAllApp',
      name: 'InstituteAllApp',
      component: () => import('@/views/app/instituteAll')
    },
    {
      path: '/instituteInfoApp',
      name: 'InstituteInfoApp',
      component: () => import('@/views/app/instituteInfo')
    },
    {
      path: '/customerServiceApp',
      name: 'CustomerServiceApp',
      component: () => import('@/views/app/customerService')
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution
    },
    {
      path: '/cooperation',
      name: 'Cooperation',
      component: Cooperation
    },
    {
      path: '/institute',
      name: 'Institute',
      component: Institute
    },
    {
      path: '/instituteInfo',
      name: 'InstituteInfo',
      component: InstituteInfo
    },
    {
      path: '/sysIntro',
      name: 'SysIntro',
      component: () => import('@/views/pc/sysIntro')
    },
    {
      path: '/aboutInfo',
      name: 'AboutInfo',
      component: () => import('@/views/pc/aboutInfo')
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js